<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter17">
<h1><a id="page_35"></a><a href="#/003toc#ch17">Grandma’s Che Che Bean Soup</a></h1>
<p class="noindent">My Italian <i>nona</i>, Aleandra, used to make this soup with garbanzo beans. As a kid I found it warm, filling, and a delight to the senses. The aroma of its inviting flavors of rosemary, garlic, and tomato mingled with garbanzo beans, vegetables, and pasta were more than I could resist. The slow cooker does a great job with this soup and will keep it warm for those who come in from the cold at different times. The vegetables can go directly into the slow cooker, but sautéing them first gives the soup a much richer flavor.</p>
<p class="noindent">3 tablespoons olive oil</p>
<p class="noindent">1 large sweet onion, such as Vidalia, finely chopped</p>
<p class="noindent">3 stalks celery, finely chopped</p>
<p class="noindent">2 carrots, finely chopped</p>
<p class="noindent">3 cloves garlic, finely chopped</p>
<p class="noindent">2 tablespoons finely chopped fresh rosemary</p>
<p class="noindent">One 14- to 15-ounce can crushed tomatoes, with their juice</p>
<p class="noindent">4 cups vegetable broth</p>
<p class="noindent">Two 14- to 15-ounce cans garbanzo beans, drained and rinsed</p>
<p class="noindent">2 cups cooked small pasta, such as ditalini or tubetti</p>
<p class="noindent">½ cup freshly grated Pecorino-Romano cheese for garnishing</p>
<p class="noindent">heat the oil in a skillet over medium-high heat. Add the onion, celery, carrots, garlic, and rosemary and sauté until the vegetables begin to soften and are fragrant, 3 to 4 minutes.</p>
<p class="noindent">add the tomatoes and sauté for another minute to incorporate. Transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker and add the broth and garbanzo beans.</p>
<p class="noindent">cover and cook on low for 6 hours or on high for 3 hours. Remove the cover, stir in the pasta, and cook for an additional 20 minutes on low or 10 minutes on high.</p>
<p class="noindent">serve the soup garnished with the cheese.</p>
<p class="noindent">serves 8</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/> cheese savvy</p>
<p class="noindent">If you have rind from Parmigiano-Reggiano cheese, add it to this soup to simmer all day; it becomes soft and chewy and rounds out the flavor of your soup.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 023-chapter17.vue?42ef7328